import type { ColumnMeta } from "@/v2-backoffice-client/components/table"
import type { LayerFragment } from "@/v2-backoffice-client/layer/__types__/layer.fragment"

/** Column id of LAYER_SEARCH_COLUMN: the key in the column map and the target of `<Table.Search column>`. */
export const LAYER_SEARCH_COLUMN_ID = "Search"

/**
 * Virtual column (never rendered) carrying the toolbar search of every layer
 * table — map layers, review queue, rejected. Column filters AND together,
 * so one filter over both fields is the only way to get "name OR code" out
 * of a single search box: a code pasted from the app, a runbook or a Linear
 * issue then finds the row as readily as its name does.
 */
export const LAYER_SEARCH_COLUMN: ColumnMeta<LayerFragment> = {
  id: LAYER_SEARCH_COLUMN_ID,
  label: "Name or code",
  virtual: true,
  enableSorting: false,
  getValue: (row) => `${row.Name} ${row.FeatureCode}`,
}

/** Placeholder of the search box that targets LAYER_SEARCH_COLUMN. */
export const LAYER_SEARCH_PLACEHOLDER = "Search by name or code..."
